import { EmailField } from "@inputs/text/EmailField";
import { Stack, Typography } from "@mui/material";
import { type Control, Controller } from "react-hook-form";
import type { INotifyByEmailModalForm } from "../types";

interface ICcInputProps {
  control: Control<INotifyByEmailModalForm, void>;
}
export const CcInput = ({ control }: ICcInputProps) => {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
      }}
    >
      <Typography
        variant="body1"
        sx={{
          minWidth: "7%",
          whiteSpace: "nowrap",
        }}
      >
        Cc :
      </Typography>
      <Controller
        control={control}
        name="cc"
        render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
          <EmailField
            value={value ?? []}
            onChange={onChange}
            size="small"
            fullWidth
            error={Boolean(error)}
            helperText={error?.message}
            inputRef={ref}
          />
        )}
      />
    </Stack>
  );
};
